export default __webpack_public_path__ + "static/home-slide004-3cc000d52579ccc4d0058c0db44bfcd2.jpg";